module.exports = __webpack_public_path__ + "img/section3_5.bdbdaaf0.png";